import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'app-square-input',
	templateUrl: './square-input.component.html',
	styleUrls: ['./square-input.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SquareInputComponent),
			multi: true,
		},
	],
})
export class SquareInputComponent implements OnInit, ControlValueAccessor {
	@Input() placeholder = '';
	@Input() type = 'password';
	@Input() errorMessage = '';
	@Input() value = '';

	localType = '';
	onChange: any = () => {};
	onTouched: any = () => {};
	disabled = false;

	constructor() {}

	ngOnInit(): void {
		this.localType = this.type;
	}

	public writeValue(value: string): void {
		this.value = value;
	}

	input(event: any): void {
		this.onChange(event.target.value);
	}

	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	public setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	onBlur(): void {
		this.onTouched();
	}
}
